<template>
    <div class="vehicle-image-container">
        <img
            class="vehicle-image"
            :src="vehicleData.photo"
            alt="Foto do veículo"
        />

        <div class="vehicle-badge">
            <span v-if="vehicleData">
                {{ getVehicleDescription() }}
                <div class="plate-container">
                    <i class="fas fa-car-side"></i>
                    {{ getVehicleBoard() }}
                </div>
            </span>
            <span v-else>Veículo não encontrado</span>
        </div>
    </div>
</template>
<script>
import {shouldHideVehicleData} from "../../../composables/useVehicleVisibility";

export default {
    name: "ImageVehicle",
    props: {
        vehicleData: {
            type: Object,
            default: () => ({})
        },
        reserveData: {
            type: Object,
            default: null
        }
    },
    methods: {
        getVehicleDescription() {
            const user = this.$store.state.user;

            // Se temos dados de reserva, usamos para verificar ocultação
            if (this.reserveData && shouldHideVehicleData(user, this.reserveData)) {
                return 'Veículo Oculto';
            }

            // Se não temos reserveData mas o usuário tem nível baixo, ocultamos
            if (!this.reserveData && user && user.access_nivel < 3) {
                return 'Veículo Oculto';
            }

            return this.vehicleData.description || 'N/A';
        },
        getVehicleBoard() {
            const user = this.$store.state.user;

            // Se temos dados de reserva, usamos para verificar ocultação
            if (this.reserveData && shouldHideVehicleData(user, this.reserveData)) {
                return '***-***';
            }

            // Se não temos reserveData mas o usuário tem nível baixo, ocultamos
            if (!this.reserveData && user && user.access_nivel < 3) {
                return '***-***';
            }

            return this.vehicleData.board || '***-***';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/Components/ImageVehicle.vue